import { createSlice } from "@reduxjs/toolkit";

const PHASES = ["pre_match", "first_half", "halftime", "second_half", "extra_time", "fulltime"];

const emptyRules = () =>
    Object.fromEntries(PHASES.map((p) => [p, { ad_campaign_id: null, ad_campaign: null, display_duration_seconds: null }]));

const initialState = {
    wizardStep:        1,
    selectedSchedule:  null,
    phaseRules:        emptyRules(),
    selectedSmartId:   null,
};

const smartAdSchedulerSlice = createSlice({
    name: "smartAdScheduler",
    initialState,
    reducers: {
        setWizardStep:       (state, { payload }) => { state.wizardStep       = payload; },
        setSelectedSchedule: (state, { payload }) => { state.selectedSchedule = payload; },
        setPhaseRule:        (state, { payload: { phase, field, value } }) => {
            state.phaseRules[phase][field] = value;
        },
        setSelectedSmartId:  (state, { payload }) => { state.selectedSmartId  = payload; },
        resetWizard: (state) => {
            state.wizardStep       = 1;
            state.selectedSchedule = null;
            state.phaseRules       = emptyRules();
        },
    },
});

export const {
    setWizardStep,
    setSelectedSchedule,
    setPhaseRule,
    setSelectedSmartId,
    resetWizard,
} = smartAdSchedulerSlice.actions;

export default smartAdSchedulerSlice.reducer;
